import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const EventIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <defs>
        <polygon id="path-1" points="0 30 30 30 30 0 0 0"></polygon>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g id="Event">
          <path
            d="M0,15 C0,23.284 6.716,30 15,30 C23.284,30 30,23.284 30,15 C30,6.716 23.284,0 15,0 C6.716,0 0,6.716 0,15"
            fill="#882A8A"
            id="Fill-1"
          ></path>
          <path
            d="M21.7807,21.8358 L8.0377,21.8358 C7.5167,21.8358 7.0947,21.4128 7.0947,20.8918 L7.0947,9.7478 C7.0947,9.2268 7.5167,8.8038 8.0377,8.8038 L21.7807,8.8038 C22.3017,8.8038 22.7247,9.2268 22.7247,9.7478 L22.7247,20.8918 C22.7247,21.4128 22.3017,21.8358 21.7807,21.8358"
            fill="#ffffff"
            className={styles.white}
            id="Fill-3"
          ></path>
          <path
            d="M10.0002,11.1456 C9.4812,11.1456 9.0612,10.7256 9.0612,10.2066 L9.0612,7.2676 C9.0612,6.7486 9.4812,6.3286 10.0002,6.3286 C10.5192,6.3286 10.9392,6.7486 10.9392,7.2676 L10.9392,10.2066 C10.9392,10.7256 10.5192,11.1456 10.0002,11.1456"
            fill="#ffffff"
            className={styles.white}
            id="Fill-5"
          ></path>
          <path
            d="M10.0002,11.1456 C9.4812,11.1456 9.0612,10.7256 9.0612,10.2066 L9.0612,7.2676 C9.0612,6.7486 9.4812,6.3286 10.0002,6.3286 C10.5192,6.3286 10.9392,6.7486 10.9392,7.2676 L10.9392,10.2066 C10.9392,10.7256 10.5192,11.1456 10.0002,11.1456 Z"
            id="Stroke-7"
            stroke="#882A8A"
            strokeWidth="0.5"
          ></path>
          <path
            d="M13.2202,11.1456 C12.7012,11.1456 12.2812,10.7256 12.2812,10.2066 L12.2812,7.2676 C12.2812,6.7486 12.7012,6.3286 13.2202,6.3286 C13.7392,6.3286 14.1592,6.7486 14.1592,7.2676 L14.1592,10.2066 C14.1592,10.7256 13.7392,11.1456 13.2202,11.1456"
            fill="#ffffff"
            className={styles.white}
            id="Fill-9"
          ></path>
          <path
            d="M13.2202,11.1456 C12.7012,11.1456 12.2812,10.7256 12.2812,10.2066 L12.2812,7.2676 C12.2812,6.7486 12.7012,6.3286 13.2202,6.3286 C13.7392,6.3286 14.1592,6.7486 14.1592,7.2676 L14.1592,10.2066 C14.1592,10.7256 13.7392,11.1456 13.2202,11.1456 Z"
            id="Stroke-11"
            stroke="#882A8A"
            strokeWidth="0.5"
          ></path>
          <path
            d="M16.431,11.1456 C15.912,11.1456 15.492,10.7256 15.492,10.2066 L15.492,7.2676 C15.492,6.7486 15.912,6.3286 16.431,6.3286 C16.95,6.3286 17.37,6.7486 17.37,7.2676 L17.37,10.2066 C17.37,10.7256 16.95,11.1456 16.431,11.1456"
            fill="#ffffff"
            className={styles.white}
            id="Fill-13"
          ></path>
          <path
            d="M16.431,11.1456 C15.912,11.1456 15.492,10.7256 15.492,10.2066 L15.492,7.2676 C15.492,6.7486 15.912,6.3286 16.431,6.3286 C16.95,6.3286 17.37,6.7486 17.37,7.2676 L17.37,10.2066 C17.37,10.7256 16.95,11.1456 16.431,11.1456 Z"
            id="Stroke-15"
            stroke="#882A8A"
            strokeWidth="0.5"
          ></path>
          <path
            d="M19.6642,11.1456 C19.1452,11.1456 18.7252,10.7256 18.7252,10.2066 L18.7252,7.2676 C18.7252,6.7486 19.1452,6.3286 19.6642,6.3286 C20.1832,6.3286 20.6032,6.7486 20.6032,7.2676 L20.6032,10.2066 C20.6032,10.7256 20.1832,11.1456 19.6642,11.1456"
            fill="#ffffff"
            className={styles.white}
            id="Fill-17"
          ></path>
          <path
            d="M19.6642,11.1456 C19.1452,11.1456 18.7252,10.7256 18.7252,10.2066 L18.7252,7.2676 C18.7252,6.7486 19.1452,6.3286 19.6642,6.3286 C20.1832,6.3286 20.6032,6.7486 20.6032,7.2676 L20.6032,10.2066 C20.6032,10.7256 20.1832,11.1456 19.6642,11.1456 Z"
            id="Stroke-19"
            stroke="#882A8A"
            strokeWidth="0.5"
          ></path>
          <mask fill="white" id="mask-2">
            <use xlinkHref="#path-1"></use>
          </mask>
          <g id="Clip-22"></g>
          <polygon
            fill="#882A8A"
            id="Fill-21"
            mask="url(#mask-2)"
            points="11.364 14.573 13.302 14.573 13.302 12.444 11.364 12.444"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-23"
            mask="url(#mask-2)"
            points="13.979 14.573 15.917 14.573 15.917 12.444 13.979 12.444"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-24"
            mask="url(#mask-2)"
            points="16.549 14.573 18.487 14.573 18.487 12.444 16.549 12.444"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-25"
            mask="url(#mask-2)"
            points="18.983 14.573 20.921 14.573 20.921 12.444 18.983 12.444"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-26"
            mask="url(#mask-2)"
            points="8.831 17.149 10.769 17.149 10.769 15.02 8.831 15.02"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-27"
            mask="url(#mask-2)"
            points="11.364 17.149 13.302 17.149 13.302 15.02 11.364 15.02"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-28"
            mask="url(#mask-2)"
            points="13.979 17.149 15.917 17.149 15.917 15.02 13.979 15.02"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-29"
            mask="url(#mask-2)"
            points="16.549 17.149 18.487 17.149 18.487 15.02 16.549 15.02"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-30"
            mask="url(#mask-2)"
            points="18.983 17.149 20.921 17.149 20.921 15.02 18.983 15.02"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-31"
            mask="url(#mask-2)"
            points="8.831 19.821 10.769 19.821 10.769 17.692 8.831 17.692"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-32"
            mask="url(#mask-2)"
            points="11.364 19.821 13.302 19.821 13.302 17.692 11.364 17.692"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-33"
            mask="url(#mask-2)"
            points="13.979 19.821 15.917 19.821 15.917 17.692 13.979 17.692"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-34"
            mask="url(#mask-2)"
            points="16.549 19.821 18.487 19.821 18.487 17.692 16.549 17.692"
          ></polygon>
          <polygon
            fill="#882A8A"
            id="Fill-35"
            mask="url(#mask-2)"
            points="18.983 19.821 20.921 19.821 20.921 17.692 18.983 17.692"
          ></polygon>
        </g>
      </g>
    </Icon>
  )
}
